import { render, staticRenderFns } from "./PlantKnowledge.vue?vue&type=template&id=fa66c410&lang=html"
import script from "./PlantKnowledge.vue?vue&type=script&lang=js"
export * from "./PlantKnowledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports